import React from "react";
import ReactMarkdown from "react-markdown";
import { Link } from "gatsby-plugin-intl";

const MarkdownRenderer = ({ children }) => {
  //console.log("children: ".children);
  return (
	<ReactMarkdown
		components={{
		  a: ({ href, children, ...props }) => {
		  // Если ссылка ведет на определенный домен, заменяем на Link
		  if (href.startsWith("/faq")) {
			return (
			  <Link to="/faq" {...props}>
				{children}
			  </Link>
			);
		  }
		  
		  if (href.startsWith("/contact")) {
			return (
			  <Link to="/contact" {...props}>
				{children}
			  </Link>
			);
		  }		  
		  
		  if (href.startsWith("/strategies")) {
			return (
			  <Link to={href} {...props}>
				{children}
			  </Link>
			);
		  }		
		  
		  if (href.startsWith("/settings")) {
			return (
			  <Link to="/settings" {...props}>
				{children}
			  </Link>
			);
		  }				  
		  
		  // Иначе рендерим как обычную ссылку
		  return (
			<a href={href} {...props}>
			  {children}
			</a>
		  );
		},
		}}					

		>{children}
	</ReactMarkdown>	
  );
};

export default MarkdownRenderer;